module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.RU.56adc6ba.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.RU.png
// module id = 1048
// module chunks = 16